// extracted by mini-css-extract-plugin
module.exports = {"Calculator":"Calculator_Calculator__3eXJz"};